import React from "react";
import { SHOW_PIECES } from "../../constants/piecesIcon";
import { FaClock } from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";
import moment from "jalali-moment";
import BlueLoader from "../loader/BlueLoader";

export default function ServiceHistoryBox({
  type,
  status,
  servicerMan,
  date,
  time,
  address,
  referenceId,
  setIsCancelServicePlaceOpen,
  setCancelType,
  cancelRefId,
  setCancelRefId,
  isCancelLoading,
}) {
  const getServiceType = () => {
    switch (type) {
      case "battery":
        return "باطری";
      case "tire":
        return "لاستیک";
    }
  };
  const getServiceStatus = () => {
    switch (status) {
      case "end":
        return " سرویس با موفقیت انجام شده است";
      case "cancel":
        return " سرویس لغو شده است";
      case "current":
        return "سرویس در حال انجام می‌باشد";
    }
  };

  const cancelService = () => {
    setIsCancelServicePlaceOpen(true);
    setCancelRefId(referenceId);
    setCancelType(getServiceType());
  };
  return (
    <div className="relative w-[92.68867924528302vw] h-auto rounded-[1.886792452830189vw] flex flex-col items-center justify-between  border-color-primary-D border-[1px] bg-[#10242b] py-[2vw] ">
      <div className="w-full  flex items-center justify-start gap-x-[2vw] ">
        <div className="">
          {SHOW_PIECES(`${type}`, "#00F7FF", "18vw", "18vw")}
        </div>
        <div className="w-full  flex flex-col items-center justify-between gap-y-[2vw]">
          <div className="w-full flex items-center justify-start">
            <span className="font-font_primary_A text-[4vw] text-color-primary-A font-bold">
              سرویس <span> </span>
              {getServiceType()}
            </span>
          </div>
          <div className="w-full flex items-center justify-start">
            <span className="font-font_primary_A text-[2.5vw] text-color-primary-A font-bold">
              {getServiceStatus()}
            </span>
          </div>
        </div>
      </div>

      <div className="w-full  flex items-center justify-between px-[4vw] font-font_primary_A text-color-primary-A text-[3.5vw] ">
        <div className="w-1/2 flex items-center justify-start gap-x-[2vw] font-extralight singleLine">
          <span>سرویس کار:</span>
          <span>{servicerMan}</span>
        </div>
        <div className=" flex items-center justify-end  ">
          {status === "current" && (
            <button
              className="w-[22vw] flex items-center justify-center  bg-[#DABBBB] text-[#AF3434] text-[3vw] font-font_primary_A font-semibold py-[1vw] rounded-[1vw]"
              onClick={cancelService}
            >
              لغو سرویس
            </button>
          )}
        </div>
      </div>

      <div className="w-full flex items-center justify-center px-[4vw] my-[3vw] ">
        <div className="w-full h-[1px]  bg-color-primary-C3 "></div>
      </div>

      <div className="w-full  flex items-center justify-start gap-x-[4vw] px-[4vw] font-font_primary_A text-color-primary-A text-[3.5vw] ">
        <div className="flex items-center justify-start gap-x-[1vw] ">
          <span className="text-color-primary-C3 text-[5vw]">
            <FaClock />
          </span>
          <span className="pt-[0.5vw]">
            {moment(new Date(date)).locale("fa").format("YYYY/M/D")}{" "}
          </span>
        </div>

        <div className="flex items-center justify-start gap-x-[1vw] pt-[0.5vw]">
          <span>ساعت</span>
          <span>{time}</span>
        </div>
      </div>
      <div className="w-full  flex items-center justify-start gap-x-[4vw] px-[4vw] font-font_primary_A text-color-primary-A text-[3.5vw] ">
        <div className="flex items-center justify-start gap-x-[1vw] ">
          <span className="text-color-primary-C3 text-[5vw]">
            <IoLocationSharp />
          </span>
          <span className="pt-[0.5vw] text-[3vw] ">{address}</span>
        </div>
      </div>

      <div className="w-full flex items-center justify-center px-[4vw] my-[3vw] ">
        <div className="w-full h-[1px]  bg-color-primary-C3 "></div>
      </div>

      <div className="w-full  flex items-center justify-between px-[4vw] font-font_primary_A text-color-primary-A text-[3vw] font-thin">
        <span>شناسه سرویس:</span>
        <span>{referenceId}</span>
      </div>
      {isCancelLoading && cancelRefId === referenceId && (
        <div className="absolute w-full h-full backdrop-blur-sm bg-[#10242b38] top-0  rounded-[2vw] flex items-center justify-center">
          <BlueLoader position="" width={15} />
        </div>
      )}
    </div>
  );
}
